import { render, staticRenderFns } from "./AdministrativePermitsView.vue?vue&type=template&id=5f2d92ad&scoped=true"
import script from "./AdministrativePermitsView.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsView.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsView.vue?vue&type=style&index=0&id=5f2d92ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d92ad",
  null
  
)

export default component.exports